module.exports = __webpack_public_path__ + "img/header-bkg-lrg.bfb4cd97.jpg";